import {Component, OnInit} from '@angular/core';
import {GenerateTokenModule} from '../../opd/generate-token/generate-token.module';
import {ListofTokenGeneratedModule} from '../../opd/listof-token-generated/listof-token-generated.module';
import {COVID, Aarogyam, Iilds, Nepal, Tata, Medikal, Turkish, W2H, NMMC, viewpatientimage, Karad, GrandPort, fingerprinturl, fingerprintimg, Shatabdi, Tawau} from '../../shared/my-constants';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']	
})
export class SidebarComponent implements OnInit {
    userAccess: Array<any> = [];
    currentUseraction: Array<any> = [];
    currentUserdetails: any;
    homeButtonShow = false;
    // Module Access
    uaIPD: boolean;
    uaOPD: boolean;
    uaTokenDisplay: boolean;
    uaNewTokenDisplay: boolean;
    uaIPDTokenDisplay: boolean;
    uaAccounting: boolean;
    uaRadiology: boolean;
    uaPharmacy: boolean;
    uaExpenseManagement: boolean;
    uaBloodTransfussion: boolean;
    uaMCI: boolean;
    uaShortEMR: boolean;
    smEmrPatReg: boolean;
    smEmrPatQueue: boolean;
    smEmrPatList: boolean;
    uaPathology: boolean;
    uaOperationTheatre: boolean;
    uaNursingStation: boolean;
    uaInventory: boolean;
    uaEmergency: boolean;
    smEmgRegistrationList: boolean;
    uaBilling: boolean;
    uaAmbulanceRequisition: boolean;
    uaDms: boolean;
    uaCSSD: boolean;
    uaMourtury: boolean;
    uaAdmissionConfig: boolean;
    uaBillingConfig: boolean;
    uaDoctorScheduleConfig: boolean;
    uaEMRConfig: boolean;
    uaInventoryConfig: boolean;
    uaOTConfig: boolean;
    uaPathologyConfig: boolean;
    uaRadiologyConfig: boolean;
    uaUnitConfig: boolean;
    uaNursingStationConfig: boolean;
    uaPatientConfig: boolean;
    // SubModule Access
    // Emergency
    smPatientRegistration: boolean;
    smRegistrationList: boolean;
    smAdviceDischargeList: boolean;
    // IPD
    smAdmission: boolean;
    smIPDAdmissionList: boolean;
    smIPDNewAdmissionRequest: boolean;
    smIPDAdmissionRequestList: boolean;
    smDischargeList: boolean;
    smAdmCancelList: boolean;
    smBedTransfer: boolean;
    smMultiBedManagement: boolean;
    smUnderMaintenance: boolean;
    smGraphicalView: boolean;
    smDischarge: boolean;
    smDischargeSummary: boolean;
    // OPD
    smGenerateToken: boolean;
    smListofTokenGenerated: boolean;
    smQueue: boolean;
    smQueueByDept: boolean;
    smQuickPatReg: boolean;
    smAppointmentList: boolean;
    smPortalAppointmentList: boolean;
    smAppointmentNew: boolean;
    smAppointmentDoctorScheduleChart: boolean;
    smAppointmentExisting: boolean;
    smRegistration: boolean;
    smOPDVisitList: boolean;
    smFollowUpList: boolean;
    // Operation Theatre
    smOTSchedule: boolean;
    smOTSchedulerList: boolean;
    smOTRequest: boolean;
    smOTScheduler: boolean;
    // Nursing Station
    smAdmissionList: boolean;
    smBirthCertificate: boolean;
    smStillBirthCertificate: boolean;
    smDeathCertificate: boolean;
    smPostMortemCertificate: boolean;
    smNursingConsole: boolean;
    smStaffDirectory: boolean;
    //Billing
    smBillList: boolean;
    smCompanyBillList: boolean;
    smDoctorShare: boolean;
    smCreditBillSettlement: boolean;
    smCancelBillList: boolean;
    smBillRefund: boolean;
    smAdvance: boolean;
    smEMGBill: boolean;
    smOPDBill: boolean;
    smIPDCharges: boolean;
    smAutoChargesReview: boolean;
    smIPDBill: boolean;
    smBillEstimation: boolean;
    smAccountingInterface: boolean;
    smPaymentSettlementSelf: boolean;
    smPaymentSettlementCompany: boolean;
    smPatientAdvnace: boolean;
    smCompanyAdvnace: boolean;
    smRefundBill: boolean;
    smCancellationBill: boolean;
    smCancellationReceipt: boolean;
    smClaimsBillProcessing: boolean;
    smClaimsBillSettlement: boolean;
    smClaimsBillResubmission: boolean;
    smClaimsRemittance: boolean;
    smDocotrsShareView: boolean;
    smDocotrsShareManagement: boolean;
    smDocotrsShareSettlement: boolean;
    smHealthPlanScheduler: boolean;
    smHealthPlanConsumption: boolean;
    smMiscellaneousIncome: boolean;
    smMiscellaneousExpense: boolean;
    smMiscellaneousBankDeposit: boolean;
    // Pathology
    smLabOrderList: boolean;
    smLabReports: boolean;
    smTestOursourceProfit: boolean;
    // Radiology
    smRadiologyLabOrder: boolean;
    smPACS: boolean;
    //Blood-Transfussion
    smDonorList: boolean;
    smRequisitionList: boolean;
    // Pharmacy
    smPharmacyStore: boolean;
    smPharmacyBillList: boolean;
    smPharmacyReturnItem: boolean;
    smPharmacyBillSettlement: boolean;
    smPharmacyBillEdit: boolean;
    smPharmacyNursingIndent: boolean;
    // Inventory
    smStoreIndent: boolean;
    smIssuetoClinic: boolean;
    smReceiveIssue: boolean;
    smOpeningBalance: boolean;
    smSupplierPortal: boolean;
    smItemEnquiry: boolean;
    smQuotation: boolean;
    smCurrentStock: boolean;
    smStockcunsumption: boolean;
    smGoodReceiveNote: boolean;
    smReturnItems: boolean;
    smGeneratePO: boolean;
    smAdjustStock: boolean;
    smScrapeSale: boolean;
//
    uaPatientConsole: boolean;
    uaMisReport: boolean;
    uaUserManagement: boolean;
    uaSystemConfiguration: boolean;
    uaDashboard: boolean;
    uaEmr: boolean;
    uaAppointment: boolean;
    uaRegistration: boolean;
    uaQueue: boolean;
    smPayouts: boolean;
    covid: Boolean = COVID;

    constructor() {
    }

    ngOnInit() {
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.userAccess = JSON.parse(sessionStorage.getItem('useraction'));
        this.currentUseraction = JSON.parse(sessionStorage.getItem('useraction'));
        this.userCompAccess();
        this.loadUserSubModule();
    }

    userCompAccess() {
        let flag = false;
        for (let i = 0; i < this.userAccess.length; i++) {
            if (this.userAccess[i].aurActionModuleName == 'OPD') {
                this.uaOPD = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'IPD') {
                this.uaIPD = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Token Display') {
                this.uaTokenDisplay = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'New Token Display') {
                this.uaNewTokenDisplay = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'IPD Token Display') {
                this.uaIPDTokenDisplay = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Accounting') {
                this.uaAccounting = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Radiology') {
                this.uaRadiology = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Pharmacy') {
                this.uaPharmacy = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Pathology') {
                this.uaPathology = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Operation Theater') {
                this.uaOperationTheatre = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Nursing Station') {
                this.uaNursingStation = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Inventory') {
                this.uaInventory = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Billing') {
                this.uaBilling = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Ambulance Requisition') {
                this.uaAmbulanceRequisition = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Admission Configuration') {
                this.uaAdmissionConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Billing Configuration') {
                this.uaBillingConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Doctor Schedule Configuration') {
                this.uaDoctorScheduleConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'EMR Configuration') {
                this.uaEMRConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Blood Transfusion') {
                this.uaBloodTransfussion = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Expense Management') {
                this.uaExpenseManagement = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'MCI') {
                this.uaMCI = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Inventory Configuration') {
                this.uaInventoryConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'OT Configuration') {
                this.uaOTConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Pathology Configuration') {
                this.uaPathologyConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Ambulance Requisition') {
                this.uaAmbulanceRequisition = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Document Management System') {
                this.uaDms = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'CSSD') {
                this.uaCSSD = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Mourtury') {
                this.uaMourtury = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'ShortEMR') {
                this.uaShortEMR = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Radiology Configuration') {
                this.uaRadiologyConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Unit Configuration') {
                this.uaUnitConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Nursing Station Configuration') {
                this.uaNursingStationConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Patient Configuration') {
                this.uaPatientConfig = true;
            }
            else if (this.userAccess[i].aurActionModuleName == 'Emergency') {
                this.uaEmergency = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'Emergency' && this.userAccess[i].aurActionSubModuleName == 'Registration') {
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'Emergency' && this.userAccess[i].aurActionSubModuleName == 'Registration List') {
                flag = true;
                this.smEmgRegistrationList = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'OPD' && this.userAccess[i].aurActionSubModuleName == 'Queue') {
                this.uaQueue = true;
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'OPD' && this.userAccess[i].aurActionSubModuleName == 'Appointment List') {
                this.uaAppointment = true;
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'OPD' && this.userAccess[i].aurActionSubModuleName == 'Registration') {
                this.uaRegistration = true;
                this.uaOPD = true;
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'OPD' && this.userAccess[i].aurActionSubModuleName == 'OPD Visit List') {
                this.uaPatientConsole = true;
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'MIS' && this.userAccess[i].aurActionSubModuleName == 'MIS Report') {
                this.uaMisReport = true;
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'MIS' && this.userAccess[i].aurActionSubModuleName == 'Dashboard') {
                this.uaDashboard = true;
                flag = true;
            }
            if (this.userAccess[i].aurActionModuleName == 'EMR') {
                this.uaEmr = true;
            }
        }
        if (flag || this.uaIPD || this.uaTokenDisplay || this.uaNewTokenDisplay || this.uaRadiology || this.uaPharmacy || this.uaPathology || this.uaOperationTheatre || this.uaOperationTheatre || this.uaNursingStation || this.uaInventory || this.uaBilling || this.uaAmbulanceRequisition || this.uaEmr || this.uaDms || this.uaCSSD || this.uaMourtury || this.uaBloodTransfussion || this.uaExpenseManagement || this.uaShortEMR) {
            console.log(flag, ' : ', this.uaIPD, ' : ', this.uaTokenDisplay, ' : ', this.uaNewTokenDisplay, ' : ', this.uaRadiology, ' : ', this.uaPharmacy, ' : ', this.uaPathology, ' : ', this.uaOperationTheatre, ' : ', this.uaOperationTheatre, ' : ', this.uaNursingStation, ' : ', this.uaInventory, ' : ', this.uaBilling, ' : ', this.uaAmbulanceRequisition, ' : ', this.uaEmr, ':', this.uaDms, ':', this.uaCSSD, ':', this.uaMourtury, ':', this.uaBloodTransfussion, ':', this.uaShortEMR, ':', this.uaExpenseManagement);
            this.homeButtonShow = true;
            console.log('hello :', this.homeButtonShow);
        }
    }

    loadUserSubModule() {
        for (let ua of this.userAccess) {

            // if (ua.aurActionSubModuleName == 'IPD' || 'Token Display' || 'Radiology' || 'Pharmacy' || 'Pathology' || 'Operation Theatre' || 'Nursing Station' || 'Inventory' || 'Ambulance Requisition' || 'Emergency' || 'Billing' || 'EMR') {
            //     this.homeButtonShow = true;
            //     console.log('111');
            // }
            // if (ua.aurActionModuleName == 'OPD' && (ua.aurActionSubModuleName == 'Queue' || 'Appointment List' || 'OPD Visit List' || 'Registration'))  {
            //     this.homeButtonShow = true;
            //            console.log('222');
            // }
            // if(ua.aurActionModuleName == 'MIS' && (ua.aurActionSubModuleName == 'MIS Report' || 'Dashboard')){
            //          this.homeButtonShow = true;
            //          console.log('333');
            // }
            // --------
            if (ua.aurActionSubModuleName == 'Queue' && ua.aurActionModuleName == 'OPD') {
                this.smQueue = true;
            }
            if (ua.aurActionSubModuleName == 'QueueByDept' && ua.aurActionModuleName == 'OPD') {
                this.smQueueByDept = true;
            }

            if (ua.aurActionSubModuleName == 'Quick Patient Registration' && ua.aurActionModuleName == 'OPD') {
                this.smQuickPatReg = true;
            }
            if (ua.aurActionSubModuleName == 'Token Generate' && ua.aurActionModuleName == 'OPD') {
                this.smGenerateToken = true;
            }
            if (ua.aurActionSubModuleName == 'Token Generated List' && ua.aurActionModuleName == 'OPD') {
                this.smListofTokenGenerated = true;
            }
            else if (ua.aurActionSubModuleName == 'Appointment List' && ua.aurActionModuleName == 'OPD') {
                this.smAppointmentList = true;
            }
            else if (ua.aurActionSubModuleName == 'Portal Appointment List' && ua.aurActionModuleName == 'OPD') {
                this.smPortalAppointmentList = true;
            }
            else if (ua.aurActionSubModuleName == 'Registration' && ua.aurActionModuleName == 'OPD') {
                this.smRegistration = true;
            }
            else if (ua.aurActionSubModuleName == 'Registration List' && ua.aurActionModuleName == 'OPD') {
                this.smRegistrationList = true;
            }
            else if (ua.aurActionSubModuleName == 'OPD Visit List' && ua.aurActionModuleName == 'OPD') {
                this.smOPDVisitList = true;
            }
            else if (ua.aurActionSubModuleName == 'Appointment New' && ua.aurActionModuleName == 'OPD') {
                this.smAppointmentNew = true;
            }
            else if (ua.aurActionSubModuleName == 'Doctor Schedule Chart' && ua.aurActionModuleName == 'OPD') {
                this.smAppointmentDoctorScheduleChart = true;
            }
            else if (ua.aurActionSubModuleName == 'Appointment Existing' && ua.aurActionModuleName == 'OPD') {
                this.smAppointmentExisting = true;
            }
            if (ua.aurActionSubModuleName == 'Admission' && ua.aurActionModuleName == 'IPD') {
                this.smAdmission = true;
            }
            else if (ua.aurActionSubModuleName == 'Admission List' && ua.aurActionModuleName == 'IPD') {
                this.smIPDAdmissionList = true;
            }
            else if (ua.aurActionSubModuleName == 'New Admission Request' && ua.aurActionModuleName == 'IPD') {
                this.smIPDNewAdmissionRequest = true;
            }
            else if (ua.aurActionSubModuleName == 'List of Admission Request' && ua.aurActionModuleName == 'IPD') {
                this.smIPDAdmissionRequestList = true;
            }
            else if (ua.aurActionSubModuleName == 'Discharge List' && ua.aurActionModuleName == 'IPD') {
                this.smDischargeList = true;
            }
            else if (ua.aurActionSubModuleName == 'Admission Cancel List' && ua.aurActionModuleName == 'IPD') {
                this.smAdmCancelList = true;
            }
            else if (ua.aurActionSubModuleName == 'Bed Transfer' && ua.aurActionModuleName == 'IPD') {
                this.smBedTransfer = true;
            }
            else if (ua.aurActionSubModuleName == 'Bed UnderMaintenance' && ua.aurActionModuleName == 'IPD') {
                this.smUnderMaintenance = true;
            }
            else if (ua.aurActionSubModuleName == 'Bed Graphical View' && ua.aurActionModuleName == 'IPD') {
                this.smGraphicalView = true;
            }
            else if (ua.aurActionSubModuleName == 'Discharge Summary' && ua.aurActionModuleName == 'IPD') {
                this.smDischargeSummary = true;
            }
            else if (ua.aurActionSubModuleName == 'Discharge' && ua.aurActionModuleName == 'IPD') {
                this.smDischarge = true;
            }
            else if (ua.aurActionSubModuleName == 'Bill List' && ua.aurActionModuleName == 'Billing') {
                this.smBillList = true;
            }
            else if (ua.aurActionSubModuleName == 'Company Bill List' && ua.aurActionModuleName == 'Billing') {
                this.smCompanyBillList = true;
            }
            else if (ua.aurActionSubModuleName == 'Doctor Share' && ua.aurActionModuleName == 'Billing') {
                this.smDoctorShare = true;
            }
            else if (ua.aurActionSubModuleName == 'Credit Bill Settlement' && ua.aurActionModuleName == 'Billing') {
                this.smCreditBillSettlement = true;
            }
            else if (ua.aurActionSubModuleName == 'Cancelled Bill List' && ua.aurActionModuleName == 'Billing') {
                this.smCancelBillList = true;
            }
            else if (ua.aurActionSubModuleName == 'Advance' && ua.aurActionModuleName == 'Billing') {
                this.smAdvance = true;
            }
            else if (ua.aurActionSubModuleName == 'Bill Refund' && ua.aurActionModuleName == 'Billing') {
                this.smBillRefund = true;
            }
            else if (ua.aurActionSubModuleName == 'Accounting Interface' && ua.aurActionModuleName == 'Billing') {
                this.smAccountingInterface = true;
            }
            else if (ua.aurActionSubModuleName == 'EMG Bill' && ua.aurActionModuleName == 'Billing') {
                this.smEMGBill = true;
            }
            else if (ua.aurActionSubModuleName == 'OPD Bill' && ua.aurActionModuleName == 'Billing') {
                this.smOPDBill = true;
            }
            else if (ua.aurActionSubModuleName == 'IPD Charges' && ua.aurActionModuleName == 'Billing') {
                this.smIPDCharges = true;
            }
            else if (ua.aurActionSubModuleName == 'Auto Charges Review' && ua.aurActionModuleName == 'Billing') {
                this.smAutoChargesReview = true;
            }
            else if (ua.aurActionSubModuleName == 'IPD Bill' && ua.aurActionModuleName == 'Billing') {
                this.smIPDBill = true;
            }
            else if (ua.aurActionSubModuleName == 'Bill Estimation' && ua.aurActionModuleName == 'Billing') {
                this.smBillEstimation = true;
            }
            else if (ua.aurActionSubModuleName == 'Payment Settlement Self' && ua.aurActionModuleName == 'Billing') {
                this.smPaymentSettlementSelf = true;
            }
            else if (ua.aurActionSubModuleName == 'Payment Settlement Company' && ua.aurActionModuleName == 'Billing') {
                this.smPaymentSettlementCompany = true;
            }
            else if (ua.aurActionSubModuleName == 'Bill Cancellation' && ua.aurActionModuleName == 'Billing') {
                this.smCancellationBill = true;
            }
            else if (ua.aurActionSubModuleName == 'Bill Receipt Cancellation' && ua.aurActionModuleName == 'Billing') {
                this.smCancellationReceipt = true;
            }
            else if (ua.aurActionSubModuleName == 'Claims Bill Processing' && ua.aurActionModuleName == 'Billing') {
                this.smClaimsBillProcessing = true;
            }
            else if (ua.aurActionSubModuleName == 'Claims Bill Settlement' && ua.aurActionModuleName == 'Billing') {
                this.smClaimsBillSettlement = true;
            }
            else if (ua.aurActionSubModuleName == 'Claims Bill Resubmission' && ua.aurActionModuleName == 'Billing') {
                this.smClaimsBillResubmission = true;
            }
            else if (ua.aurActionSubModuleName == 'Claims Remittance' && ua.aurActionModuleName == 'Billing') {
                this.smClaimsRemittance = true;
            }
            else if (ua.aurActionSubModuleName == 'Doctor Share View' && ua.aurActionModuleName == 'Billing') {
                this.smDocotrsShareView = true;
            }
            else if (ua.aurActionSubModuleName == 'Doctor Share Management' && ua.aurActionModuleName == 'Billing') {
                this.smDocotrsShareManagement = true;
            }
            else if (ua.aurActionSubModuleName == 'Doctor Share Settlement' && ua.aurActionModuleName == 'Billing') {
                this.smDocotrsShareSettlement = true;
            }
            else if (ua.aurActionSubModuleName == 'Health Plan Scheduler' && ua.aurActionModuleName == 'Billing') {
                this.smHealthPlanScheduler = true;
            }
            else if (ua.aurActionSubModuleName == 'Health Plan Consumption' && ua.aurActionModuleName == 'Billing') {
                this.smHealthPlanConsumption = true;
            } else if (ua.aurActionSubModuleName == 'Miscellaneous Income' && ua.aurActionModuleName == 'Billing') {
                this.smMiscellaneousIncome = true;
            } else if (ua.aurActionSubModuleName == 'Miscellaneous Expense' && ua.aurActionModuleName == 'Billing') {
                this.smMiscellaneousExpense = true;
            } else if (ua.aurActionSubModuleName == 'Miscellaneous Bank Deposit' && ua.aurActionModuleName == 'Billing') {
                this.smMiscellaneousBankDeposit = true;
            } else if (ua.aurActionSubModuleName == 'Patient Registration' && ua.aurActionModuleName == 'Emergency') {
                this.smPatientRegistration = true;
            } else if (ua.aurActionSubModuleName == 'Advice Discharge List' && ua.aurActionModuleName == 'Emergency') {
                this.smAdviceDischargeList = true;
            } else if (ua.aurActionSubModuleName == 'OT Schedule' && ua.aurActionModuleName == 'Operation Theater') {
                this.smOTSchedule = true;
            } else if (ua.aurActionSubModuleName == 'OT Request' && ua.aurActionModuleName == 'Operation Theater') {
                this.smOTRequest = true;
            } else if (ua.aurActionSubModuleName == 'Schedule List' && ua.aurActionModuleName == 'Operation Theater') {
                this.smOTSchedulerList = true;
            } else if (ua.aurActionSubModuleName == 'Admission List' && ua.aurActionModuleName == 'Nursing Station') {
                this.smAdmissionList = true;
            } else if (ua.aurActionSubModuleName == 'Birth Certificate' && ua.aurActionModuleName == 'Nursing Station') {
                this.smBirthCertificate = true;
            } else if (ua.aurActionSubModuleName == 'Still Birth Certificate' && ua.aurActionModuleName == 'Nursing Station') {
                this.smStillBirthCertificate = true;
            } else if (ua.aurActionSubModuleName == 'Death Certificate' && ua.aurActionModuleName == 'Nursing Station') {
                this.smDeathCertificate = true;
            } else if (ua.aurActionSubModuleName == 'Post Mortem Certificate' && ua.aurActionModuleName == 'Nursing Station') {
                this.smPostMortemCertificate = true;
            } else if (ua.aurActionSubModuleName == 'Nursing Console' && ua.aurActionModuleName == 'Nursing Station') {
                this.smNursingConsole = true;
            } else if (ua.aurActionSubModuleName == 'Staff Directory' && ua.aurActionModuleName == 'Nursing Station') {
                this.smStaffDirectory = true;
            } else if (ua.aurActionSubModuleName == 'Lab Order List' && ua.aurActionModuleName == 'Pathology') {
                this.smLabOrderList = true;
            } else if (ua.aurActionSubModuleName == 'Lab Report' && ua.aurActionModuleName == 'Pathology') {
                this.smLabReports = true;
            } else if (ua.aurActionSubModuleName == 'Test OutSource Profit' && ua.aurActionModuleName == 'Pathology') {
                this.smTestOursourceProfit = true;
            } else if (ua.aurActionSubModuleName == 'Radiology Lab Order' && ua.aurActionModuleName == 'Radiology') {
                this.smRadiologyLabOrder = true;
            } else if (ua.aurActionSubModuleName == 'PACS' && ua.aurActionModuleName == 'Radiology') {
                this.smPACS = true;
            } else if (ua.aurActionSubModuleName == 'Pharmacy Store' && ua.aurActionModuleName == 'Pharmacy') {
                this.smPharmacyStore = true;
            } else if (ua.aurActionSubModuleName == 'Pharmacy Bill List' && ua.aurActionModuleName == 'Pharmacy') {
                this.smPharmacyBillList = true;
            } else if (ua.aurActionSubModuleName == 'Pharmacy Return Item' && ua.aurActionModuleName == 'Pharmacy') {
                this.smPharmacyReturnItem = true;
            } else if (ua.aurActionSubModuleName == 'Pharmacy Bill Settlement' && ua.aurActionModuleName == 'Pharmacy') {
                this.smPharmacyBillSettlement = true;
            } else if (ua.aurActionSubModuleName == 'Pharmacy Bill Edit' && ua.aurActionModuleName == 'Pharmacy') {
                this.smPharmacyBillEdit = true;
            } else if (ua.aurActionSubModuleName == 'Pharmacy Nursing Indent' && ua.aurActionModuleName == 'Pharmacy') {
                this.smPharmacyNursingIndent = true;
            } else if (ua.aurActionSubModuleName == 'Donor List' && ua.aurActionModuleName == 'Blood Transfusion') {
                this.smDonorList = true;
            } else if (ua.aurActionSubModuleName == 'Requisition List' && ua.aurActionModuleName == 'Blood Transfusion') {
                this.smRequisitionList = true;
            } else if (ua.aurActionSubModuleName == 'Transfer Store Indent' && ua.aurActionModuleName == 'Inventory') {
                this.smStoreIndent = true;
            } else if (ua.aurActionSubModuleName == 'Transfer Issue to Clinic' && ua.aurActionModuleName == 'Inventory') {
                this.smIssuetoClinic = true;
            } else if (ua.aurActionSubModuleName == 'Transfer Receive Issue' && ua.aurActionModuleName == 'Inventory') {
                this.smReceiveIssue = true;
            } else if (ua.aurActionSubModuleName == 'Opening Balance' && ua.aurActionModuleName == 'Inventory') {
                this.smOpeningBalance = true;
            } else if (ua.aurActionSubModuleName == 'Supplier Portal' && ua.aurActionModuleName == 'Inventory') {
                this.smSupplierPortal = true;
            } else if (ua.aurActionSubModuleName == 'Item Enquiry' && ua.aurActionModuleName == 'Inventory') {
                this.smItemEnquiry = true;
            } else if (ua.aurActionSubModuleName == 'Quotation' && ua.aurActionModuleName == 'Inventory') {
                this.smQuotation = true;
            }
            else if (ua.aurActionSubModuleName == 'Current Stock' && ua.aurActionModuleName == 'Inventory') {
                this.smCurrentStock = true;
            }
            else if (ua.aurActionSubModuleName == 'Stock Consumption' && ua.aurActionModuleName == 'Inventory') {
                this.smStockcunsumption = true;
            }
            else if (ua.aurActionSubModuleName == 'Good Receive Note' && ua.aurActionModuleName == 'Inventory') {
                this.smGoodReceiveNote = true;
            }
            else if (ua.aurActionSubModuleName == 'Return Items' && ua.aurActionModuleName == 'Inventory') {
                this.smReturnItems = true;
            }
            else if (ua.aurActionSubModuleName == 'Generate PO' && ua.aurActionModuleName == 'Inventory') {
                this.smGeneratePO = true;
            }
            else if (ua.aurActionSubModuleName == 'Adjust Stock' && ua.aurActionModuleName == 'Inventory') {
                this.smAdjustStock = true;
            }
            else if (ua.aurActionSubModuleName == 'Scrape Sale' && ua.aurActionModuleName == 'Inventory') {
                this.smScrapeSale = true;
            }
            else if (ua.aurActionSubModuleName == 'FollowUp List' && ua.aurActionModuleName == 'OPD') {
                this.smFollowUpList = true;
            }
            else if (ua.aurActionSubModuleName == 'EMR Patient Registration' && ua.aurActionModuleName == 'ShortEMR') {
                this.smEmrPatReg = true;
            }
            else if (ua.aurActionSubModuleName == 'EMR Patient Queue' && ua.aurActionModuleName == 'ShortEMR') {
                this.smEmrPatQueue = true;
            }
            else if (ua.aurActionSubModuleName == 'EMR Patient List' && ua.aurActionModuleName == 'ShortEMR') {
                this.smEmrPatList = true;
            }
            else if (ua.aurActionSubModuleName == 'Payouts' && ua.aurActionModuleName == 'Accounting') {
                this.smPayouts = true;
            }
            //     this.smPatientAdvnace = true;
            //    this.smCompanyAdvnace = true;
            //     this.smRefundBill = true;
            //   this.smAdvance = true;
            //    this.smIPDCharges = true;
        }
    }

    userSubModuleAccess(subModule: any) {
        if (subModule == 'Emergency') {
            // this.smPatientRegistration = true;
            // this.smRegistrationList = true;
            // this.smAdviceDischargeList = true;
        }
        else if (subModule == 'OPD') {

            // this.smQueue = true;
            // this.smAppointmentList = true;
            // this.smAppointmentNew = true;
            // this.smAppointmentExisting = true;
            // this.smRegistration = true;
            // this.smOPDVisitList = true;
        }
        else if (subModule == 'IPD') {


            // this.smAdmission = true;
            // this.smIPDAdmissionList = true;
            // this.smDischargeList = true;
            // this.smBedTransfer = true;
            // this.smMultiBedManagement = true;
            // this.smUnderMaintenance = true;
            // this.smGraphicalView = true;
            // this.smDischarge = true;
            // this.smDischargeSummary = true;
        }
        else if (subModule == 'Operation Theatre') {
            //  this.smOTSchedule = true;
            //  this.smOTScheduler = true;
        }
        else if (subModule == 'Nursing Station') {
            // this.smAdmissionList = true;
            // this.smBirthCertificate = true;
            // this.smStillBirthCertificate = true;
            // this.smDeathCertificate = true;
            // this.smPostMortemCertificate = true;
            // this.smNursingConsole = true;
        }
        else if (subModule == 'Billing') {
            /* this.smBillList = true;
             this.smBillRefund = true;
             this.smAdvance = true;
             this.smOPDBill = true;
             this.smIPDCharges = true;
             this.smAutoChargesReview = true;
             this.smIPDBill = true;
             this.smBillEstimation = true;
             this.smAccountingInterface = true;
             this.smPaymentSettlementSelf = true;
             this.smPaymentSettlementCompany = true;
             this.smPatientAdvnace = true;
             this.smCompanyAdvnace = true;
             this.smRefundBill = true;
             this.smCancellationBill = true;
             this.smCancellationReceipt = true;
             this.smClaimsBillProcessing = true;
             this.smClaimsBillSettlement = true;
             this.smClaimsBillResubmission = true;
             this.smClaimsRemittance = true;
             this.smDocotrsShareView = true;
             this.smDocotrsShareManagement = true;
             this.smDocotrsShareSettlement = true;
             this.smHealthPlanScheduler = true;
             this.smHealthPlanConsumption = true;
             this.smMiscellaneousIncome = true;
             this.smMiscellaneousExpense = true;
             this.smMiscellaneousBankDeposit = true;*/
        }
        else if (subModule == 'Pathology') {
            // this.smLabOrderList = true;
            // this.smLabReports = true;
            // this.smTestOursourceProfit = true;
        }
        else if (subModule == 'Radiology') {
            // this.smRadiologyLabOrder = true;
            // this.smPACS = true;
        }
        else if (subModule == 'Pharmacy') {
            // this.smPharmacyStore = true;
            // this.smPharmacyBillList = true;
            // this.smPharmacyReturnItem = true;
        }
        else if (subModule == 'Inventory') {
            // this.smStoreIndent = true;
            // this.smIssuetoClinic = true;
            // this.smReceiveIssue = true;
            // this.smOpeningBalance = true;
            // this.smItemEnquiry = true;
            // this.smQuotation = true;
            // this.smCurrentStock = true;
            // this.smGoodReceiveNote = true;
            // this.smReturnItems = true;
            // this.smGeneratePO = true;
            // this.smAdjustStock = true;
            // this.smScrapeSale = true;
        }
        else if (subModule == 'Token Display') {
            this.uaTokenDisplay = true;
        }
        else if (subModule == 'New Token Display') {
            this.uaNewTokenDisplay = true;
        }
        else if (subModule == 'IPD Token Display') {
            this.uaIPDTokenDisplay = true;
        }
        else if (subModule == 'Ambulance Requisition') {
            this.uaAmbulanceRequisition = true;
        }
        else if (subModule == 'Document Management System') {
            this.uaDms = true;
        }
        else if (subModule == 'CSSD') {
            this.uaCSSD = true;
        }
        else if (subModule == 'Mourtury') {
            this.uaMourtury = true;
        }
        else if (subModule == 'Blood Transfusion') {
            this.uaBloodTransfussion = true;
        }
        else if (subModule == 'Expense Management') {
            this.uaExpenseManagement = true;
        }
        else if (subModule == 'MCI') {
            this.uaMCI = true;
        }
        else if (subModule == 'ShortEMR') {
            this.uaShortEMR = true;
        }
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/sidebar/sidebar.component.ts